import { render, staticRenderFns } from "./Herramientas.vue?vue&type=template&id=6d0a04e8&scoped=true"
import script from "./Herramientas.vue?vue&type=script&lang=js"
export * from "./Herramientas.vue?vue&type=script&lang=js"
import style0 from "./Herramientas.vue?vue&type=style&index=0&id=6d0a04e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0a04e8",
  null
  
)

export default component.exports